import React from 'react'

function ErrorPage({errorCode,content,href,hrefTag}) {
    return (
        <>
        <div className='flex justify-center items-center my-32 pt-20'>
            <div className="text-center ">
                <h1 className="mb-4 text-7xl font-semibold text-gray-600">{errorCode}</h1>
                <p className="mb-4 text-lg text-gray-700">{content}</p>
                {/* Oops! Looks like you're not Authorized. */}
                <div className="animate-bounce">
                    <svg className="mx-auto h-16 w-16 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"></path>
                    </svg>
                </div>
                <p className="mt-4 text-gray-600">Let's get you back to <a href={href} className="text-blue-500">{hrefTag}</a>.</p>
            </div>
        </div >
    
    </>
      )
}

export default ErrorPage